import React from 'react';
import EndUserManageContainer from '@src/containers/EndUser';

const EndUser = () => <EndUserManageContainer />;

export default EndUser;
